<script setup>
import {nextTick, reactive, ref} from 'vue';
import Modal from "@/components/Shared/Modal";
import FormInput from "@/components/Shared/Form/Input/Index";
import FormButton from "@/components/Shared/Form/Button";

const emit = defineEmits(['confirmed']);

const confirmingPassword = ref(false);
const form = reactive({
  password: '',
  error: '',
  processing: false,
});

const passwordInput = ref(null);
const startConfirmingPassword = () => {
  axios.get(route('password.confirmation')).then(response => {
    if (response.data.confirmed) {
      emit('confirmed');
    } else {
      confirmingPassword.value = true;
    }
  });
};

const confirmPassword = () => {
  form.processing = true;
  axios.post(route('password.confirm'), {
    password: form.password,
  }).then(() => {
    form.processing = false;
    closeModal();
    nextTick().then(() => emit('confirmed'));
  }).catch(error => {
    form.processing = false;
    form.error = error.response.data.errors.password[0];
  });
};

const closeModal = () => {
  confirmingPassword.value = false;
  form.password = '';
  form.error = '';
};
</script>

<template>
    <span>
        <span @click="startConfirmingPassword">
            <slot/>
        </span>

        <modal :show="confirmingPassword" @close="closeModal">
            <template #title>
                {{ trans('dashboard.confirm_password.title') }}
            </template>

            <template #content>
                {{ trans('dashboard.confirm_password.description') }}

                <div class="mt-4">
                    <form-input
                      ref="passwordInput"
                      v-model="form.password"
                      type="password"
                      container-class="form-group"
                      placeholder="Password"
                      :error="form.error"
                      @keyup.enter="confirmPassword"
                      autofocus
                    />
                </div>
            </template>

            <template #footer>
                <form-button class="button_cancel" @click="closeModal" :value="trans('common.cancel')"/>

                <form-button class="ml-3"
                             :processing="form.processing"
                             @click="confirmPassword"
                             :value="trans('common.confirm')"/>
            </template>
        </modal>
    </span>
</template>
